import { DayOfWeekEnum } from "../enums/dayOfWeek.enum";
import { NotificationAveragingEnum } from "../enums/notificationAveraging.enum";
import { NotificationConditionType } from "../enums/notificationConditionType.enum";
import { NotificationLimitTypeEnum } from "../enums/notificationLimitType.enum";
import { ParameterTypeEnum } from "../enums/parameterType.enum";
import { ShiftTypeEnum } from "../enums/shiftType.enum";
import { AlertSeverityLevel } from "../enums/alert.enum";
import { SuppressRepeatModeEnum } from "../enums/suppressRepeatMode.enum";
import { Enum } from "./enum.model";
import { UserLookup } from "./userLookup.model";

export class NotificationSettings {
    id: string;
    isEnabled: boolean;
    name: string;
    parameterId: string;
    parameterName: string;
    parameterType: ParameterTypeEnum;
    averagingType: NotificationAveragingEnum;
    shiftType: ShiftTypeEnum;
    workingDays: DayOfWeekEnum[];
    shifts: ShiftRange[];
    limit: number;
    limitType: NotificationLimitTypeEnum;
    conditionType: NotificationConditionType;
    threshold: number;
    timePeriod: number;
    createdByUserId: string;
    subscribers: string[];
    subscribedEmails: string[];
    applyFogCorrection: boolean;
    organizationLevelId?: string;
    severity?: AlertSeverityLevel;
    hysteresisSeconds?: number | null;
    autoEscalateAfterMinutes?: number | null;
    sourceRuleId?: string | null;
    repeatCountThreshold?: number | null;
    repeatWindowMinutes?: number | null;
    tierGroupId?: string | null;
    tierLevel?: number | null;
    responseAction?: string;
    controlIds?: string[];
    evaluationCadenceMinutes?: number | null;
    // UI-only: not persisted, stripped in onBeforeSave — derived from evaluationCadenceMinutes on load.
    isCadenceEnabled?: boolean;
    suppressRepeatMode?: SuppressRepeatModeEnum;
    suppressRepeatForMinutes?: number | null;
}

export class NotificationSettingsData {
    averagingTypes: Enum[];
    shiftTypes: Enum[];
    limitTypes: Enum[];
    daysOfWeek: Enum[];
    conditionTypes: Enum[];
    admins: UserLookup[];
    severities: Enum[];
    suppressRepeatModes: Enum[];
}

export class ShiftRange {
    startTime: number;
    endTime: number;
    startDate: Date | String;
    endDate: Date | String;

    constructor(sTime?: number, eTime?: number, sDate?: Date | String, eDate?: Date | String) {
        this.startTime = sTime;
        this.endTime = eTime;
        this.startDate = sDate;
        this.endDate = eDate;
    }
}
